import React, { useEffect, useState } from "react";
import { GrFormNextLink } from "react-icons/gr";
import "../styles/recharge.css";
import AccountLayout from "../layouts/AccountLayout";
import { useNavigate } from "react-router-dom";
import { createTransaction } from "../api/transaction.api";
import { ClipLoader } from "react-spinners";
import ToastNotification, {
  showToast,
  showTopCenterToast,
} from "../components/toasts/ToastNotification";

const BankTransfer = () => {
  const [amount, setAmount] = useState(0);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleRecharge = async () => {
    if (amount < 10000) {
      showTopCenterToast("Số tiền nạp tối thiểu phải là 10.000đ", "error");
      return;
    }

    if (amount > 10000000) {
      showTopCenterToast("Số tiền nạp tối đa phải là 10.000.000đ", "error");
      return;
    }

    setLoading(true);
    try {
      const res = await createTransaction(
        amount,
        "empty_gateway",
        "bank_transfer"
      );

      if (res.success) {
        setLoading(false);
        navigate(`/payment/bank-transfer/${res?.data?.transactionId}`);
      }
    } catch (error) {
      setLoading(false);
      showToast(error.message, "error");
    }
  };

  return (
    <AccountLayout title="Nạp tiền qua ngân hàng">
      <div className="recharge-container">
        <h2>Nạp tiền qua ngân hàng</h2>

        <AmountSelection
          amount={amount}
          setAmount={setAmount}
          loading={loading}
          onRecharge={handleRecharge}
        />
        <ToastNotification />
      </div>
    </AccountLayout>
  );
};

const AmountSelection = ({
  amount,
  setAmount,
  onRecharge,
  loading,
}) => (
  <>
    <div className="amount-options">
      <p className="deposit-des">Nhập số tiền bạn muốn nạp vào đây</p>
      <input
        type="text"
        value={amount.toLocaleString()}
        onChange={(e) => setAmount(Number(e.target.value.replace(/\D/g, '')))}
        className="user-deposit-amount-input"></input>
    </div>
    <div className="recharge-button-wrapper">
      <button
        onClick={onRecharge}
        disabled={amount == 0}
        className="recharge-button"
      >
        {loading ? (
          <ClipLoader size={20} color="#fff" />
        ) : (
          <GrFormNextLink className="recharge-icon" />
        )}
      </button>
    </div>
  </>
);

export default BankTransfer;
